<template>
    <div class="modal fade bd-example-modal-xl" id="modalConsulta" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Detalles</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-if="datoDetallesPersona.PersonaId>0"> 
                    <div v-if="AreaId!=40">
                        <ul class="nav nav-tabs" id="myTab" role="tablist" >
                            <li class="nav-item">
                                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#Personales" role="tab" aria-controls="Personales" aria-selected="true">Personales</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Academicos" role="tab" aria-controls="Academicos" aria-selected="false">Académicos</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Laborales" role="tab" aria-controls="Laborales" aria-selected="false">Laborales</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Familiares" role="tab" aria-controls="Familiares" aria-selected="false">Familiares</a>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent" >
                            <div class="tab-pane fade show active" id="Personales" role="tabpanel" aria-labelledby="home-tab" >
                                <br>
                                <div class="row">
                                    <div class="col-2 text-center" v-if="datoDetallesPersona.PersonaId>0">
                                        <RostroDePersona  
                                            :personaId="datoDetallesPersona.PersonaId"       
                                            :conBotonDeSubidor="false"        
                                            :conBotonDeDescarga="false"              
                                        >
                                        </RostroDePersona>
                                    </div>
                                    <div class="col-10" >
                                        <div class="row">
                                            <div class="form-group col-2">
                                                <label>Nombre:</label>
                                            </div>
                                            <div class="form-group col-6">
                                                <label>{{datoDetallesPersona.NombreCompleto}}</label>
                                            </div>
                                            <div class="form-group col-2">
                                                <label>No. Nomina:</label>
                                            </div>
                                            <div class="form-group col-2">
                                                <label>{{datoDetallesPersona.NumeroNomina}}</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col-2">
                                                <label>Estado Civil:</label>
                                            </div>
                                            <div class="form-group col-4">
                                                <label>{{datoDetallesPersona.TipoEstadoCivil.Nombre}}</label>
                                            </div>
                                            <div class="form-group col-2">
                                                <label>Sexo:</label>
                                            </div>
                                            <div class="form-group col-4">
                                                <label>{{datoDetallesPersona.TipoSexo.Nombre}}</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col-2">
                                                <label>E-Mail:</label>
                                            </div>
                                            <div class="form-group col-4">
                                                <label>{{datoDetallesPersona.CorreoElectronico}}</label>
                                            </div>
                                            <div class="form-group col-2">
                                                <label>NSS:</label>
                                            </div>
                                            <div class="form-group col-4">
                                                <label>{{datoDetallesPersona.NSS}}</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col-2">
                                                <label>RFC:</label>
                                            </div>
                                            <div class="form-group col-4">
                                                <label>{{datoDetallesPersona.RFC}}</label>
                                            </div>
                                            <div class="form-group col-2">
                                                <label>F. de Nac.:</label>
                                            </div>
                                            <div class="form-group col-4">
                                                <label>{{datoDetallesPersona.FechaNacimiento}}</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col-2">
                                                <label>Lugar de Nac.:</label>
                                            </div>
                                            <div class="form-group col-4">
                                                <label>{{datoDetallesPersona.Municipio!=null ? datoDetallesPersona.Municipio.Nombre : ''}}, {{datoDetallesPersona.EntidadFederativa!=null ? datoDetallesPersona.EntidadFederativa.Nombre : ''}}, {{datoDetallesPersona.Pais!=null ? datoDetallesPersona.Pais.Nombre : ''}} </label>
                                            </div>
                                            <div class="form-group col-2">
                                                <label>CURP:</label>
                                            </div>
                                            <div class="form-group col-4">
                                                <label>{{datoDetallesPersona.CURP}}</label>
                                            </div>
                                        </div>
                                        
                                        <div class="row">
                                            <div class="form-group col-4">
                                                <label>Domicilio Actual</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col-2">
                                                <label>Calle y Num:</label>
                                            </div>
                                            <div class="form-group col-10">
                                                <label>{{datoDetallesPersona.Domicilio.Calle}} No. Ext: # {{datoDetallesPersona.Domicilio.NumeroExterno}}, No. Int. # {{datoDetallesPersona.Domicilio.NumeroExterno}}</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col-2">
                                                <label>Fracc / Col :</label>
                                            </div>
                                            <div class="form-group col-4">
                                                <label>{{datoDetallesPersona.Domicilio!=null ? datoDetallesPersona.Domicilio.FraccColonia : ''}}, C.P. : {{datoDetallesPersona.Domicilio!=null ? datoDetallesPersona.Domicilio.CodigoPostal : ''}}</label>
                                            </div>
                                            <div class="form-group col-2">
                                                <label>Localidad :</label>
                                            </div>
                                            <div class="form-group col-4">
                                                <label>{{datoDetallesPersona.Domicilio!=null ? datoDetallesPersona.Domicilio.Municipio.Nombre : ''}}, {{datoDetallesPersona.Domicilio!=null ? datoDetallesPersona.Domicilio.EntidadFederativa.Nombre : ''}}</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col-4">
                                                <label>Telefonos</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col-2">
                                                <label>Movil:</label>
                                            </div>
                                            <div class="form-group col-2">
                                                <label>{{datoDetallesPersona.Telefonos.length>0? datoDetallesPersona.Telefonos[0].NumeroTelefono : ''}}</label>
                                            </div>
                                            <div class="form-group col-2">
                                                <label>Casa:</label>
                                            </div>
                                            <div class="form-group col-2">
                                                <label>{{datoDetallesPersona.Telefonos.length>0? datoDetallesPersona.Telefonos[1].NumeroTelefono : ''}}</label>
                                            </div>
                                            <div class="form-group col-2">
                                                <label>Otro:</label>
                                            </div>
                                            <div class="form-group col-2">
                                                <label>{{datoDetallesPersona.Telefonos.length>0? datoDetallesPersona.Telefonos[2].NumeroTelefono : ''}}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="Academicos" role="tabpanel" aria-labelledby="profile-tab" >
                                <br>
                                <div id="tabla_Academico" >
                                    <table class="table table-striped table-light table-hover table-sm table-bordered">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th>Fecha Inicio</th>
                                            <th>Fecha Conclusión</th>
                                            <th>Institución</th>
                                            <th>Nivel Académico</th>
                                            <th>Documento Obtenido</th>
                                        </tr>
                                        </thead>
                                        <tbody class="text-dark">
                                        <tr v-if="datoDetallesPersona.HistoriaAcademica.length <= 0">
                                            <td colspan="12" class="text-center">Sin Historia Academica</td>
                                        </tr>
                                        <tr v-else v-for="Lista in datoDetallesPersona.HistoriaAcademica" :key ="Lista.HistoriaAcademicaId">
                                            <td v-html="obtenFechaConFormato(Lista.FechaInicio)"></td>
                                            <td v-html="obtenFechaConFormato(Lista.FechaFin)"></td>
                                            <td>{{Lista.Institucion}}</td>
                                            <td>{{Lista.TipoNivelAcademico.Nombre}}</td>
                                            <td>{{Lista.TipoTitulo!=null ? Lista.TipoTitulo.Nombre : ''}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="Laborales" role="tabpanel" aria-labelledby="profile-tab">
                                <br>
                                <div id="tabla_Laboral">
                                    <table class="table table-striped table-light table-hover table-sm table-bordered">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th>Fecha Inicio</th>
                                            <th>Fecha Conclusión</th>
                                            <th>Área</th>
                                            <th>Departamento</th>
                                            <th>Puesto</th>
                                            <th>Movimiento</th>
                                            <th>Plaza</th>
                                            <th>Baja</th>

                                        </tr>
                                        </thead>
                                        <tbody class="text-dark">
                                        <tr v-if="datoDetallesPersona.HistorialLaboral.length <= 0">
                                            <td colspan="12" class="text-center">Sin Historia Laboral</td>
                                        </tr>
                                        <tr v-else v-for="Lista in datoDetallesPersona.HistorialLaboral" :key ="Lista.HistoriaLaboralId">
                                            <td v-html="obtenFechaConFormato(Lista.FechaInicial)"></td>
                                            <td v-html="obtenFechaConFormato(Lista.FechaFinal)"></td>
                                            <td>{{Lista.EstructuraOrganica.TipoDepartamentoArea!=null ? Lista.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre : ''}}</td>
                                            <td>{{Lista.EstructuraOrganica.TipoDepartamentoArea!=null ? (Lista.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento!=null ? Lista.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre : 'Sin Departamento') :''}}</td>
                                            <td>{{Lista.EstructuraOrganica.Puesto!=null ? Lista.EstructuraOrganica.Puesto.Nombre :''}}</td>
                                            <td>{{Lista.TipoMovimiento.NombreMovimiento}}</td>
                                            <td>{{Lista.EstructuraOrganica.TipoPlaza.Nombre}}</td>
                                            <td>{{Lista.CausoBaja==true?'SI':'NO'}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="Familiares" role="tabpanel" aria-labelledby="profile-tab" >
                                <br>
                                <div id="tabla_Familiar">
                                    <table class="table table-striped table-light table-hover table-sm table-bordered">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Parentesco</th>
                                            <th>Dep. Económico</th>
                                            <th>Fec. Nac.</th>
                                            <th>Finado</th>
                                            <th>Domicilio</th>
                                        </tr>
                                        </thead>
                                        <tbody class="text-dark">
                                        <tr v-if="datoDetallesPersona.HistorialLaboral.length <= 0">
                                            <td colspan="12" class="text-center">Sin Historia Laboral</td>
                                        </tr>
                                        <tr v-else v-for="Lista in datoDetallesPersona.Familiares" :key ="Lista.FamiliarlId">
                                            <td>{{Lista.Nombre}} {{Lista.ApellidoPaterno}} {{Lista.ApellidoMaterno}}</td>
                                            <td>{{Lista.TipoParentesco.Nombre}}</td>
                                            <td>{{Lista.DependienteEconomico==true? 'SI' : 'NO'}}</td>
                                            <td v-html="obtenFechaConFormato(Lista.FechaNacimiento)"></td>
                                            <td>{{Lista.FinadoFamiliar==true ? 'SI' : 'NO'}}</td>
                                            <td>{{Lista.Domicilio.Calle}} No. {{Lista.Domicilio.NumeroExterno}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <h6>Historial Laboral</h6>
                        <br>
                        <div id="tabla_Laboral">
                            <table class="table table-striped table-light table-hover table-sm table-bordered">
                                <thead class="thead-dark">
                                    <tr>
                                            <th>Fecha Inicio</th>
                                            <th>Fecha Conclusión</th>
                                            <th>Área</th>
                                            <th>Departamento</th>
                                            <th>Puesto</th>
                                            <th>Movimiento</th>
                                            <th>Plaza</th>
                                            <th>Baja</th>

                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                        <tr v-if="datoDetallesPersona.HistorialLaboral.length<=0">
                                            <td colspan="12" class="text-center">Sin Historia Laboral</td>
                                        </tr>
                                        <tr v-else v-for="Lista in datoDetallesPersona.HistorialLaboral" :key ="Lista.HistoriaLaboralId">
                                            <td v-html="obtenFechaConFormato(Lista.FechaInicial)"></td>
                                            <td v-html="obtenFechaConFormato(Lista.FechaFinal)"></td>
                                            <td>{{Lista.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre}}</td>
                                            <td>{{Lista.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento!=null ? Lista.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre : 'Sin Departamento'}}</td>
                                            <td>{{Lista.EstructuraOrganica.Puesto!=null ? Lista.EstructuraOrganica.Puesto.Nombre :''}}</td>
                                            <td>{{Lista.TipoMovimiento.NombreMovimiento}}</td>
                                            <td>{{Lista.EstructuraOrganica.TipoPlaza.Nombre}}</td>
                                            <td>{{Lista.CausoBaja==true?'SI':'NO'}}</td>
                                        </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-secondary" id="botonCancelar" >Cancelar</button> -->
                    <button type="button" class="btn btn-dark" id="botonAceptar" >Aceptar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'

import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
//import M_Persona from "../Comun/Modelos/Persona";

export default {
    props:  {
        persona: Object
    },
    components :{
        RostroDePersona: catalogos.SIAP.RostroDePersona
    },
    data(){
        return {
            datoDetallesPersona : {
                PersonaId: 0,
                HistoriaAcademica: [],
                HistorialLaboral: [
                {
                    TipoDepartamentoArea : {
                        TipoDepartamentoAreaId :0,
                        Area: {
                            AreaId: 0,
                            Nombre: null
                        },
                        TipoDepartamento : {
                            TipoDepartamentoId: 0,
                            Nombre: null
                        }
                    }
                }
            ]
           },
           AreaId : 0
        }
    },
    methods: {
        Mostrar: function () {
        $('#modalConsulta').modal('show');
        //$('#botonCancelar').unbind('click').click(this.ModalClose);
        $('#closeModal').unbind('click').click(this.ModalClose);
        $('#botonAceptar').unbind('click').click(this.ModalClose);
        },
        ModalClose: function(){
            $('#modalConsulta').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', {"Salir" : true });
        },
        CargarDatosDePersona(personaCURP) {
            comun.SeEstaCargandoInformacion(true);
            let peticion = {
                CURP: personaCURP,
                ConInactivos: "true",
                ConDomicilio: "true",
                ConTipoEstadoCivil: "true",
                ConSexo: "true",
                ConPais: "true",
                ConEntidadFederativa: "true",
                ConMunicipio: "true",
                ConTelefonos: "true",
                ConHistorialAcademico: "true",
                ConHistorialLaboral: "true",
                ConRelacionSuperiores: "true",
                ConFamiliares: "true",
                ConContrato: "true",
                ConFotoDelRostro: "true",
                ConImagenDeFirmaAutografa: "true"
            };
            axios
            .post(
            api.conexion + api.SIAP.funcion.GetPersona,
            peticion,
            comun.CrearElHeaderDeAutorizacion(
                this.$store.state.Login_AutorizacionOriginal
            )
            )
            .then(response => {
            if (response.data.SiHayError == false) {
                //Formatea los campos de fecha
                var FechaNacimientoFormato = moment(
                response.data.Persona.FechaNacimiento
                ).format("DD-MM-YYYY");
                response.data.Persona.FechaNacimiento = FechaNacimientoFormato;
                this.datoDetallesPersona = response.data.Persona;
                
                this.datoDetallesPersona.HistorialLaboral.sort((a,b)=>(a.HistoriaLaboralId<b.HistoriaLaboralId ? 1:-1))
                this.$nextTick(()=> { PaginarTabla('tabla_Academico', 5)});
                this.$nextTick(()=> { PaginarTabla('tabla_Laboral', 5)});
                this.$nextTick(()=> { PaginarTabla('tabla_Familiar', 5)});

        
            } else {
                console.log(response);
                comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            }
            comun.SeEstaCargandoInformacion(false);
            })
            .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
        },
        obtenFechaConFormato: function(fechaRegistro) {
            if(fechaRegistro!=null)
            {
                return moment(fechaRegistro).format("DD-MM-YYYY");
            }
        }
    },
    mounted(){
        //console.log(this.persona)
        this.CargarDatosDePersona(this.persona.CURP);
        setTimeout(()=>{
            this.Mostrar();
        }, 500);
        this.AreaId = this.$store.state.Login_Usuario.Area.AreaId;
        //this.Mostrar();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SIAP/Comun/Modales/ModalConsulta.vue